// debugLog — console.log that is silent in production builds.
//
// Client-facing consoles (advisors demo the app to clients with DevTools open)
// must stay clean. Use debugLog for diagnostic chatter; keep console.warn /
// console.error untouched so real problems remain visible in production.
const DEBUG = process.env.NODE_ENV !== 'production';

export const debugLog = (...args) => {
  if (DEBUG) console.log(...args);
};
